import React from "react";
import { Link } from "react-router-dom";
import { Award, Heart, ShieldCheck, Stethoscope, Users, BedDouble, Sparkles } from "lucide-react";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="hero-bg">
        <div className="container-x py-16">
          <span className="font-cursive text-2xl text-brand-purple">About Us</span>
          <h1 className="text-4xl sm:text-5xl font-bold mt-1">A legacy of healing, <span className="text-brand-purple">a future</span> of innovation.</h1>
          <p className="mt-5 text-slate-600 max-w-3xl leading-relaxed">One Hospitals (A Unit of Hanshi Hospitals Pvt. Ltd.) is a NABH-accredited multi-specialty hospital combining decades of clinical excellence with the latest medical technology — built around a single belief: every patient deserves world-class, dignified care.</p>
        </div>
      </section>

      <section className="section">
        <div className="container-x grid md:grid-cols-3 gap-6">
          {[{i:Heart,t:"Mission",d:"To deliver compassionate, evidence-based, and accessible healthcare to every individual we serve."},
            {i:Sparkles,t:"Vision",d:"To be South India's most trusted health partner — known for clinical excellence and patient experience."},
            {i:ShieldCheck,t:"Values",d:"Empathy. Excellence. Ethics. Innovation. Inclusivity. These five values guide every decision we make."}].map((v, i) => (
            <div key={i} className="card-clean p-7" data-testid={`mvv-${v.t.toLowerCase()}`}>
              <div className="h-12 w-12 rounded-xl bg-brand-purple/10 text-brand-purple grid place-items-center mb-4"><v.i className="h-6 w-6" /></div>
              <div className="text-xl font-semibold">{v.t}</div>
              <p className="text-slate-600 mt-2 leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section bg-slate-50">
        <div className="container-x">
          <h2 className="text-3xl font-bold text-center mb-10">Why choose One Hospitals?</h2>
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-5">
            {[{i:Award,t:"NABH Accredited", d:"Highest national standard for healthcare quality."},
              {i:Stethoscope,t:"120+ Specialists",d:"Internationally trained doctors across 22 departments."},
              {i:Users,t:"Patient-First Care",d:"Dedicated care coordinators for every patient."},
              {i:BedDouble,t:"350+ Beds",d:"Including 80+ ICU/HDU beds with modern equipment."}].map((x, i) => (
              <div key={i} className="card-clean p-6">
                <x.i className="h-7 w-7 text-brand-green mb-3" />
                <div className="font-semibold">{x.t}</div>
                <div className="text-sm text-slate-600 mt-1">{x.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container-x py-12 text-center">
        <Link to="/book-appointment" className="btn-primary" data-testid="about-cta-book">Book an Appointment</Link>
      </section>
    </div>
  );
}
